export default class Shared {
    static instance = null;

    miis = null;
    names = null;
    filters = null;
    
    static get() {
        if (Shared.instance == null) {
            Shared.instance = new Shared();
        }

        return Shared.instance;
    }

    setMiisB64(images) {
        this.miis = {};
        for(let i in images) {
            this.miis[i] = "data:image/png;base64," + images[i];
        }
    }

    setNamesB64(images) {
        this.names = {};
        for(let i in images) {
            this.names[i] = "data:image/png;base64," + images[i];
        }
    }

    getMiiB64(index) {
        if(this.miis != null) {
            return this.miis[index];
        } else {
            return -1;
        }
    }

    getNameB64(index) {
        if(this.names != null) {
            return this.names[index];
        } else {
            return -1;
        }
    }

    setFilters(filters) {
        this.filters = filters;
    }
}
